import { render } from "./UnitMonetaryModel.vue?vue&type=template&id=39cef637&scoped=true"
import script from "./UnitMonetaryModel.vue?vue&type=script&lang=js"
export * from "./UnitMonetaryModel.vue?vue&type=script&lang=js"

import "./UnitMonetaryModel.vue?vue&type=style&index=0&id=39cef637&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cef637"]])

export default __exports__